import $ from 'jquery';
import {isEmpty,get_first_tabindex,get_last_tabindex,root,locale,mediaPath,acc,loopFocus} from '../Helpers';
import {state} from '../State';
import {
    EVENT_TOGGLE_TOOLBAR,
    EVENT_ADD_CONTRAST_MONO,
    EVENT_KEYBOARD_ESC,
    BTN_KEYBOARD,
    BTN_ANIMATIONS,
    BTN_CONTRAST_MONOCHROME,
    BTN_CONTRAST_DARK,
    BTN_CONTRAST_BRIGHT,
    BTN_TEXT_SMALLER,
    BTN_TEXT_BIGGER,
    BTN_TEXT_READABLE,
    BTN_CURSOR_W,
    BTN_CURSOR_B,
    BTN_ZOOM,
    BTN_HIGHLIGHT_LINKS,
    BTN_HIGHLIGHT_TITLES,
    BTN_ALTS,
    BTN_CLEAR_ALL,
    BTN_CONTACT,
    BTN_STATEMENT} from '../Params';
import {actions} from '../Actions';
import Feedback from '../parts/Feedback';
import Statement from '../parts/Statement';
import ToolbarBtn from './ToolbarBtn';

export default  class Toolbar {

    /*todo localize!*/
    constructor() {
        this._data ={};
        this.feedback = new Feedback()
        this.statement = new Statement()
        this.buttons = {
            [BTN_KEYBOARD] :             new ToolbarBtn({id:BTN_KEYBOARD,label:'ניווט מקלדת',type:'keyboard',icon:'keyboard.svg',alt:'',className:'',show:true}),
            [BTN_ANIMATIONS] :           new ToolbarBtn({id:BTN_ANIMATIONS,label:'ביטול הבהובים',type:'animation',icon:'animations.svg',alt:'',className:'',show:true}),
            [BTN_CONTRAST_MONOCHROME] :  new ToolbarBtn({id:BTN_CONTRAST_MONOCHROME,label:'מונוכרום',type:'mono',icon:'monochrome.png',alt:'',className:'',show:true}),
            [BTN_CONTRAST_DARK] :        new ToolbarBtn({id:BTN_CONTRAST_DARK,label:'ניגודיות כהה',type:'dark',icon:'contrastD.svg',alt:'',className:'',show:true}),
            [BTN_CONTRAST_BRIGHT] :      new ToolbarBtn({id:BTN_CONTRAST_BRIGHT,label:'ניגודיות בהירה',type:'bright',icon:'contrastB.svg',alt:'',className:'',show:true}),
            [BTN_TEXT_SMALLER] :         new ToolbarBtn({id:BTN_TEXT_SMALLER,label:'הקטנת גופן',type:'smaller',icon:'fontMinus.svg',alt:'',className:'',show:true}),
            [BTN_TEXT_BIGGER] :          new ToolbarBtn({id:BTN_TEXT_BIGGER,label:'הגדלת גופן',type:'bigger',icon:'fontPlus.svg',alt:'',className:'',show:true}),
            [BTN_TEXT_READABLE] :        new ToolbarBtn({id:BTN_TEXT_READABLE,label:'גופן קריא',type:'readable',icon:'font.svg',alt:'',className:'',show:true}),
            [BTN_CURSOR_W] :             new ToolbarBtn({id:BTN_CURSOR_W,label:'סמן גדול לבן',type:'w',icon:'arrowW.svg',alt:'',className:'',show:true}),
            [BTN_CURSOR_B] :             new ToolbarBtn({id:BTN_CURSOR_B,label:'סמן גדול שחור',type:'b',icon:'arrowB.svg',alt:'',className:'',show:true}),
            [BTN_ZOOM] :                 new ToolbarBtn({id:BTN_ZOOM,label:'תצוגה מוגדלת',type:'zoom',icon:'zoom.svg',alt:'',className:'',show:true}),
            [BTN_HIGHLIGHT_LINKS] :      new ToolbarBtn({id:BTN_HIGHLIGHT_LINKS,label:'הדגשת קישורים',type:'links',icon:'links.svg',alt:'',className:'',show:true}),
            [BTN_HIGHLIGHT_TITLES] :     new ToolbarBtn({id:BTN_HIGHLIGHT_TITLES,label:'הדגשת כותרות',type:'titles',icon:'titles.svg',alt:'הדגשת כותרות',className:'',show:true}),
            [BTN_ALTS] :                 new ToolbarBtn({id:BTN_ALTS,label:'תיאור תמונה',type:'imgalt',icon:'imgAlt.svg',alt:'תיאור תמונה',className:'',show:true}),
            [BTN_CLEAR_ALL] :            new ToolbarBtn({id:BTN_CLEAR_ALL,label:'איפוס נגישות',type:'reset',className:'',show:true}),
            [BTN_CONTACT] :              new ToolbarBtn({id:BTN_CONTACT,label:locale('send_feedback'),type:'feedback',className:'',show:acc('showFeedbackForm')}),
            [BTN_STATEMENT] :            new ToolbarBtn({id:BTN_STATEMENT,label:locale('acc_statement'),type:'statement',className:'',show:true}),
        }
        this.listners()

    }

    get elem(){ return this._data.elem}
    set elem(x){ this._data.elem = x }

    get contact(){ return this._data.contact}
    set contact(x){ this._data.contact = x }

    get buttons(){ return this._data.buttons}
    set buttons(x){ this._data.buttons = x }

    get visible(){ return this._data.visible}
    set visible(x){
        if(isEmpty(this.elem)){return}
        if(this._data.visible===x){return}
        this._data.visible =x;
        this.elem.toggle(x)
        this.elem.attr('aria-hidden',(x ? 'false' : 'true'))
    }

    listners(){

        //buttons
        $(document).on('click',`#${BTN_CONTRAST_MONOCHROME}`,(e)=>actions.setContrast('mono'));
        $(document).on('click',`#${BTN_CONTRAST_DARK}`,(e)=>actions.setContrast('dark'));
        $(document).on('click',`#${BTN_CONTRAST_BRIGHT}`,(e)=>actions.setContrast('bright'));

        $(document).on('click',`#${BTN_ANIMATIONS}`,(e)=>actions.disableAnimation(e));
        $(document).on('click',`#${BTN_KEYBOARD}`,(e)=>actions.keyboardNav(e));

        $(document).on('click',`#${BTN_CURSOR_W}`,(e)=>actions.setCursor('w'));
        $(document).on('click',`#${BTN_CURSOR_B}`,(e)=>actions.setCursor('b'));
        $(document).on('click',`#${BTN_ZOOM}`,(e)=>actions.setZoom(e));

        $(document).on('click',`#${BTN_HIGHLIGHT_LINKS}`,(e)=>actions.highlightLinks(e));
        $(document).on('click',`#${BTN_HIGHLIGHT_TITLES}`,(e)=>actions.highlightTitles(e));
        $(document).on('click',`#${BTN_ALTS}`,(e)=>actions.ImagesAlt(e));

        $(document).on('click',`#${BTN_TEXT_SMALLER}`,(e)=>actions.decreaseFontSize(e));
        $(document).on('click',`#${BTN_TEXT_BIGGER}`,(e)=>actions.increaseFontSize(e));
        $(document).on('click',`#${BTN_TEXT_READABLE}`,(e)=>actions.fixFonts(e));

        $(document).on('click',`#${BTN_CLEAR_ALL}`,(e)=>actions.clearAll());
        $(document).on('click',`#${BTN_STATEMENT}`,(e)=>this.statement.get_statement());
        $(document).on('click',`#${BTN_CONTACT}`,(e)=>this.feedback.open());
        $(document).on('click','#acc-contactform-close',(e)=>this.feedback.close());

        //keyboard
        $(document).keyup((e)=>{
            //press Esc:
            let keyCode = e.keyCode || e.which;
            if (keyCode=== 27) {
                if($('.fancybox-wrap:visible').length){
                    return
                }
                if(root().isOpen){
                    $(document).trigger(EVENT_TOGGLE_TOOLBAR);
                }
                if(state.keyboardNav) {
                    root().keybord_nav.focus();
                }
                $(document).trigger(EVENT_KEYBOARD_ESC)

                if(typeof window.onEscClick === 'function'){
                    window.onEscClick()
                }

            }

        });
    }

    focus(){
        this.elem.focus()
    }
    renderHeader(){
        const header = $('<header>',{'id':'acc_header'})
        const title= $('<h2>').text(locale('accessibility_menu'))
        const close = $('<button>',{
            id:"acc-toolbar-close",
            'aria-label':locale('close_acc_menu')
        }).click(()=>{
            $(document).trigger(EVENT_TOGGLE_TOOLBAR,{isOpen:false})
        })
        header.html([title,close])
        return header
    }
    renderButtonsRow(id,buttons){
        const row = $('<div>',{id:id,'class':'amap_row'})
        let count = 0;
        buttons.forEach((b)=>{
            const btn = this.buttons[b]
            if(btn.show)count++
        })

        acc('showFeedbackForm')
        row.addClass(`amap_row${count}`)
        buttons.map((b)=>{
            const btn = this.buttons[b]
            row.append(btn.render())
        })

        return row
    }

    renderBody(){
        const body = $('<div>',{id:'acc_body'})
        const flach = $('<div class="flachbg">')
        const top_btns = $('<div>',{id:'acc_bodyTopBns'})
        const main_btns = $('<div>',{id:'acc_mainBtns'})
        top_btns.html([
            flach,
            this.renderButtonsRow('acc_row_keyboard',[BTN_KEYBOARD]),
            this.renderButtonsRow('acc_row_animation',[BTN_ANIMATIONS])
        ])
        main_btns.html([
            this.renderButtonsRow('acc-toolbar-contrast',[BTN_CONTRAST_MONOCHROME,BTN_CONTRAST_DARK,BTN_CONTRAST_BRIGHT]),
            this.renderButtonsRow('acc-toolbar-textsize',[BTN_TEXT_BIGGER,BTN_TEXT_SMALLER,BTN_TEXT_READABLE]),
            this.renderButtonsRow('acc-toolbar-ui',[BTN_CURSOR_B,BTN_CURSOR_W,BTN_ZOOM]),
            this.renderButtonsRow('acc-toolbar-elemnts',[BTN_HIGHLIGHT_LINKS,BTN_HIGHLIGHT_TITLES,BTN_ALTS]),
        ])
        body.html([top_btns,main_btns])
        return body
    }

    renderFooter(){

            const footer = $('<div>',{id:"acc_footer"})
        footer.append(this.renderButtonsRow('acc-footer-buttons',[BTN_CLEAR_ALL,BTN_CONTACT,BTN_STATEMENT]))
        footer.append(this.renderCreditRow())

        return footer;

    }

    renderCreditRow(){
        const row = $('<div>',{'class':'amap_row amap_logo'})
        const a = $('<a>',{href:'http://www.amazing.co.il',target:'_blank'})
        row.html(
            a.html(
                $(`<img src="${mediaPath('amazing_logo.png')}" alt="amazing.co.il" />`)
            ))
        return row
    }

    render(){
       this.elem = $('<div>',{id:"acc-toolbar",tabindex:"0"})
        this.elem.html([
            this.renderHeader(),
            this.renderBody(),
            this.renderFooter(),
            this.feedback.render()
        ])

        //loop focus on toolbar
        loopFocus(this.elem)

        return this.elem

    }

}
